var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17876",
    "data-name": "Group 17876",
    transform: "translate(0 0.101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "BG",
    width: 25,
    height: 26,
    rx: 12.5,
    transform: "translate(0 -0.101)",
    fill: "#f33738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M54.778,12.294l-1.043-1.738A5.163,5.163,0,0,1,53,7.9V6.377A4.257,4.257,0,0,0,49.963,2.3V1.215a1.215,1.215,0,0,0-2.429,0V2.3A4.257,4.257,0,0,0,44.5,6.377V7.9a5.166,5.166,0,0,1-.735,2.656l-1.043,1.738a.3.3,0,0,0,.26.46H54.517a.3.3,0,0,0,.261-.46Z",
    transform: "translate(-36.066 5.783)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.1040dc0eaea880633ccf03bb8abb3671.svg";
export { ForwardRef as ReactComponent };